import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "IncreaseLevel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M17.25 3L13.5 5.8125V10.6875L11.25 9L7.5 11.8125V16.6875L5.25 15L1.5 17.8125V22.5H3V18.5625L5.25 16.875L7.5 18.5625V22.5H9V12.5625L11.25 10.875L13.5 12.5625V22.5H15V6.5625L17.25 4.875L19.5 6.5625V22.5H21V5.8125L17.25 3Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/IncreaseLevel.vue"]]);
